<template>
  <div
    id="ShoppingPromises"
    class="container flex flex-col justify-center gap-10 border-t border-black-10 py-10 md:flex-row lg:gap-0 lg:py-0"
  >
    <div v-if="locale !== 'fr'" class="benefit">
      <span
        ><IconPurchaseOnInvoiceMobile
          v-if="isMobile"
          class="size-11 lg:size-14"
          alt="" />
        <IconPurchaseOnInvoice v-else class="size-11 lg:size-14" alt=""
      /></span>
      {{ $t('benefits.purchase_on_invoice') }}
    </div>
    <div v-else class="benefit">
      <span>
        <IconSince1991Mobile v-if="isMobile" class="size-11 lg:size-14" />
        <IconSince1991 v-else class="size-11 lg:size-14" />
      </span>
      {{ $t('benefits.since_1991') }}
    </div>

    <div v-if="showBenefitFreeReturns" class="benefit">
      <span
        ><IconFreeReturnsMobile
          v-if="isMobile"
          class="size-11 lg:size-14"
          alt="" />
        <IconFreeReturns v-else class="size-11 lg:size-14" alt=""
      /></span>
      {{ $t('benefits.free_returns') }}
    </div>

    <div v-if="!isBelgium && locale !== 'fr'" class="benefit benefit--hotline">
      <span>
        <IconFreeAdviceMobile
          v-if="isMobile"
          class="size-11 lg:size-14"
          alt=""
        />
        <IconFreeAdvice v-else class="size-11 lg:size-14" alt="" />
      </span>
      <span class="block text-center">
        <span class="font-medium">{{ $t('benefits.free_advice') }}</span>
        <AgsLazy>
          <Phone
            type="supportPhone"
            skip-translation
            :skip-link="!isMobile"
            class="text-[80%] leading-normal lg:text-[80%]"
          />
          <span class="block text-[90%] leading-normal lg:text-[70%]">
            {{ $t('benefits.free_advice_hint') }}
          </span>
        </AgsLazy>
      </span>
    </div>
    <div v-else-if="!isBelgium" class="benefit text-center">
      <span
        ><IconPurchaseOnInvoiceMobile
          v-if="isMobile"
          class="size-11 lg:size-14"
          alt="" />
        <IconPurchaseOnInvoice v-else class="size-11 lg:size-14" alt=""
      /></span>
      {{ $t('benefits.purchase_on_invoice') }}
      {{ $t('benefits.purchase_on_invoice_second_line') }}
    </div>
  </div>
</template>

<script lang="ts">
import useCountryCheck from '#layers/base/composables/useCountryCheck'
import Phone from '#layers/base/components/ui/floatingActionButtons/Phone.vue'
import { useDeviceType } from '~/composables/useDeviceType'

export default defineComponent({
  name: 'Benefits',
  components: {
    Phone,
  },
  setup() {
    const { isMobile } = useDeviceType()
    const { locale } = useI18n()
    const { shopId } = useCurrentShop().value
    const showBenefitFreeReturns = ![10003, 10004].includes(shopId)
    const { isInList: isBelgium } = useCountryCheck(['fr-be', 'be'])

    return {
      locale,
      showBenefitFreeReturns,
      isBelgium,
      isMobile,
    }
  },
})
</script>
<style lang="postcss" scoped>
.benefit {
  @apply flex flex-col
        justify-start
        items-center
        w-full
        lg:w-1/3
        gap-2
        lg:gap-6
        font-medium
        text-base
        lg:text-xl
        lg:p-12;
}
</style>
